<template>
    <div class="d-flex flex-column edit-title-form">
        <p class="edit-title">ADD EVENT TITLE</p>
        <input
            class="edit-form-control"
            type="text"
            v-model="title"
            placeholder="Enter event title"
        />
        <button class="save-title-btn" @click="updateTitle">Save</button>
    </div>
</template>

<script>
    import axios from 'axios'
    import { notification } from '../../../helpers/notification'
    export default {
        name: 'AddEventTitle',
        props: {
            eventInfo: {
                type: Object
            }
        },
        data() {
            return {
                title: ''
            }
        },
        computed: {
            getEventStartDate: (self) =>
                self.eventInfo.start.includes(':')
                    ? self.eventInfo.start.split(' ')[0]
                    : self.eventInfo.start
        },
        methods: {
            async updateTitle() {
                try {
                    const response = await axios.put(
                        '/event/manage/update/' + this.eventInfo.id,
                        {
                            start: this.eventInfo.getEventStartDate,
                            duration: this.eventInfo.duration,
                            recurring: this.eventInfo.recurring,
                            event_name: this.title
                        }
                    )
                    notification('success', 'Events title successfully updated')
                    if (response.status === 200) {
                        const newEventData = {
                            id: this.eventInfo.id,
                            start: this.eventInfo.start,
                            start_time: this.eventInfo.start_time,
                            duration: this.eventInfo.duration,
                            recurring: this.eventInfo.recurring,
                            event_name: this.title
                        }
                        this.$emit('updateEventData', newEventData)
                    }
                } catch (err) {
                    this.serverErrMsg = `[${err.response?.status}] : ${err.response?.data?.message}`
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../sass/_variables.scss';
    .edit-title {
        color: #dedede;
        font-family: 'Instrument Sans';
        font-size: 44px;
        font-style: normal;
        font-weight: 500;
        line-height: 110%;
        letter-spacing: -1.76px;
    }
    .edit-form-control {
        color: #fff;
        flex-shrink: 0;
        letter-spacing: -0.14px;
        width: 100%;
        padding: 0 20px;
        border-radius: 12px;
        border: 1.5px solid #8b8b8b;
        background: #262626;
    }
    .save-title-btn {
        align-items: center;
        background: #cdeb09;
        border: 0;
        border-radius: 100px;
        display: inline-flex;
        gap: 10px;
        justify-content: center;
        letter-spacing: 1.8px;
        padding: 20px;
        text-align: center;
        text-transform: uppercase;
        width: 100%;
        color: #000;
        font-family: 'Instrument Sans';
        font-size: 18px;
        font-style: normal;
        font-weight: 550;
        line-height: 120%;
    }
    .edit-title-form {
        gap: 34px;
    }
    @media (max-width: 600px) {
        .edit-title {
            font-size: 30px;
        }
    }
</style>
